module.exports = __webpack_public_path__ + "img/card-slider-yuri.fb860803.webp";